module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[10]131.850266d.woff2";